<template>
  <div class="mb-8 py-4">
    <list-applications
      :user="user"
      @application-selected="handleRedirectNewApplication"
      @your-application-selected="handleRedirectEditApplication"
    />
  </div>
</template>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout';
import Loader from '@/components/Shared/Loader';
import ListApplications from '@/components/Dashboard/ListApplications';

export default {
  name: 'Applications',

  layout: DashboardLayout,

  components: {
    Loader,
    ListApplications,
  },

  props: {
    user: Object,
  },

  methods: {
    handleRedirectNewApplication(application) {
      const data = {
        user: this.user.id,
        application: application.parent_application_id || application.id,
      };

      if (application.parent_application_id !== null) {
        data.appId = application.id;
      }

      this.$inertia.visit(this.$route('dashboard.user.applications.new', data));
    },

    handleRedirectEditApplication(application) {
      this.$inertia.visit(
        this.$route('dashboard.user.applications.edit', { user: this.user.id, application: application.id }),
      );
    },
  },
};
</script>
